import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { ViewModule } from '@mui/icons-material'

interface MenuLayoutProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuLayout = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuLayoutProps) => {
  const { formatMessage } = useIntl()

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href={`/casino/layout`}
        selected={pathname.startsWith('/casino/layout')}
      >
        <ListItemIcon>
          <ViewModule />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'casino.submenu.layout.title',
          })}
        />
      </MenuItem>
    </div>
  )
}
